export default "__VITE_ASSET__CQ8Xe2Q3__"